import { render, staticRenderFns } from "./AjustesNivelPantalla.vue?vue&type=template&id=567f5840&scoped=true"
import script from "./AjustesNivelPantalla.vue?vue&type=script&lang=js"
export * from "./AjustesNivelPantalla.vue?vue&type=script&lang=js"
import style0 from "./AjustesNivelPantalla.vue?vue&type=style&index=0&id=567f5840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f5840",
  null
  
)

export default component.exports